/**
 * Created by xsdlr on 2017/5/22.
 */
export const tryDefaultValue = (func, defaultValue) => {
  try {
    return func.apply(this) || defaultValue
  } catch (ex) {
    return defaultValue
  }
}
export const throttle = (fn, delay) => {
  return function () {
    clearTimeout(fn.tId)
    const context = this
    fn.tId = setTimeout(function () {
      fn.call(context)
    }, delay)
  }
}



// WEBPACK FOOTER //
// ./src/utils/commons.js